import { Trophy, X } from 'lucide-react'
import { useThemeOrchestratorStore } from '@/stores/themeOrchestratorStore'
import { useState, useEffect, useRef } from 'react'

export function ThemeRewardToast() {
  const unlockedThemes = useThemeOrchestratorStore((s) => s.unlockedThemes)
  const shownIdsRef = useRef<Set<string>>(new Set())
  const [visible, setVisible] = useState(false)
  const [currentReward, setCurrentReward] = useState<{ milestone: number; themeId: string } | null>(null)

  useEffect(() => {
    const newReward = unlockedThemes.find((t) => !shownIdsRef.current.has(t.unlockedAt))
    if (newReward) {
      shownIdsRef.current.add(newReward.unlockedAt)
      setCurrentReward({ milestone: newReward.milestone, themeId: newReward.themeId })
      setVisible(true)

      const timer = setTimeout(() => setVisible(false), 5000)
      return () => clearTimeout(timer)
    }
  }, [unlockedThemes])

  if (!visible || !currentReward) return null

  const themeLabel = currentReward.themeId === 'aurora' ? 'Aurora' : currentReward.themeId

  return (
    <div className="fixed top-4 right-4 z-50 animate-in slide-in-from-top-4 fade-in">
      <div className="flex items-center gap-3 px-4 py-3 bg-surface-primary rounded-xl shadow-lg border border-strong max-w-sm">
        <div className="p-2 rounded-lg bg-accent-primary">
          <Trophy className="w-4 h-4 text-accent-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-heading">테마 보상 해금!</div>
          <div className="text-xs text-caption">{currentReward.milestone}일 연속 달성 — {themeLabel} 테마 7일간 활성화</div>
        </div>
        <button
          type="button"
          onClick={() => setVisible(false)}
          className="p-1 rounded-lg hover-surface text-caption flex-shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
